var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorWizardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 12.7457C16.1087 12.7457 16.5326 12.5683 16.8452 12.2525C17.1577 11.9367 17.3333 11.5084 17.3333 11.0618V1.80067C17.3333 1.35409 17.1577 0.925792 16.8452 0.610009C16.5326 0.294226 16.1087 0.116821 15.6667 0.116821H6.88333C7.175 0.630395 7.33333 1.21132 7.33333 1.80067H15.6667V11.0618H8.16667V12.7457H15.6667ZM11.5 4.32644V6.01029H6.5V16.9553H4.83333V11.9038H3.16667V16.9553H1.5V10.2199H0.25V6.01029C0.25 5.56371 0.425595 5.13541 0.738155 4.81963C1.05072 4.50385 1.47464 4.32644 1.91667 4.32644H11.5ZM5.66667 1.80067C5.66667 2.24725 5.49107 2.67555 5.17851 2.99133C4.86595 3.30711 4.44203 3.48452 4 3.48452C3.55797 3.48452 3.13405 3.30711 2.82149 2.99133C2.50893 2.67555 2.33333 2.24725 2.33333 1.80067C2.33333 1.35409 2.50893 0.925792 2.82149 0.610009C3.13405 0.294226 3.55797 0.116821 4 0.116821C4.44203 0.116821 4.86595 0.294226 5.17851 0.610009C5.49107 0.925792 5.66667 1.35409 5.66667 1.80067Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorWizardIcon);
export default __webpack_public_path__ + "static/media/tutor-wizard-icon.25e00950.svg";
export { ForwardRef as ReactComponent };